import { CONTEXT } from '../config';

export const DISCOUNT_TABSMAP = [
  {
    text: '推荐',
    key: 1,
    path: `${CONTEXT}/discount/recommend`,
    logPageKey: 'Sales_Reco',
    aliveName: 'discountRecommend',
  },
  {
    text: '排行榜',
    key: 2,
    path: `${CONTEXT}/discount/rank`,
    logPageKey: 'Sales_Rank',
    aliveName: 'discountRank',
  },
];

export const DISCOUNT_RECOMMEND_APPTYPEENUM = [
  {},
  { name: '游戏激活码' },
  { name: '应用会员' },
  { name: '应用内购买' },
  { name: '硬件设备' },
];

export const GET_DISCOUNT_RECOMMEND_LIST = 'GET_DISCOUNT_RECOMMEND_LIST';
export const SET_DISCOUNT_RECOMMEND_LIST = 'SET_DISCOUNT_RECOMMEND_LIST';
export const GET_DISCOUNT_RANK_LIST = 'GET_DISCOUNT_RANK_LIST';
export const SET_DISCOUNT_RANK_LIST = 'SET_DISCOUNT_RANK_LIST';
export const GET_DISCOUNT_RANK_MENU = 'GET_DISCOUNT_RANK_MENU';
export const SET_DISCOUNT_RANK_MENU = 'SET_DISCOUNT_RANK_MENU';
export const SET_DISCOUNT_RANK_ORDER = 'SET_DISCOUNT_RANK_ORDER';
export const SET_DISCOUNT_RANK_TYPE = 'SET_DISCOUNT_RANK_TYPE';
